<template>
  <div class="a4">

    <!-- 사고발생 현황 -->
    <div style="margin-bottom: 40px;">
      <div class="bullseye none-colon" style="width: 180px; margin-bottom: 14px; text-align-last: justify;">사고발생 현황</div>
      <div>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="100px"/>
            <col width="150px"/>
            <col width="188px"/>
            <col width="400px"/>
            <col width="188px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th colspan="2" style="border-right: 1px solid #757575"><div style="padding: 5px 10px; text-align: center;">구  분</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">피해인원</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">사고경위 및 조치</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">비고</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in value.사고발생현황" class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td v-if="index === 0" :rowspan="value.사고발생현황.length" style="border-right: 1px solid #757575"><div>피해<br>현황</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ data.cell1 || '-'}}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ data.cell2 || '-'}}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ data.cell3 || '-'}}</div></td>
            <td><div style="padding: 5px 10px;">{{ data.cell4 || '-'}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 기타 개선 및 보완이 필요한 사항 -->
    <div style="margin-bottom: 40px; page-break-inside: avoid">
      <div class="bullseye none-colon" style="width: 380px; margin-bottom: 14px; text-align-last: justify;">기타 개선 및 보완이 필요한 사항</div>
      <div style="border: 1px solid #757575;">
        <div style="border-bottom: 1px solid #757575; padding: 20px 15px;; text-align: center; background-color: #F0F0F0; font-weight: 700; font-size: 26px;">점검결과(총평)</div>
        <div style="min-height: 740px; display: flex; align-items: center; padding: 20px 15px; font-size: 24px; white-space: pre;">{{value.기타개선및보완이필요한사항}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import PrintRadio from "@/components/print/PrintRadio.vue";
import Template from "@/views/boards/single-page/1044/print/Template.vue";

export default {
  components: {Template, PrintRadio},
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
  },
  methods: {
  }
}
</script>
